<main class="mat-body" *ngIf="client">
    <div class="container">
        <div class="row">
            <div class="col-12 pt-3">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1
                            class="text-blue mat-display-1 font-weight-bold mb-0"
                            [innerHTML]="'test.sign.title'|translate"
                            *ngIf="!isSuitability"
                        ></h1>
                        <h1
                            class="text-blue mat-display-1 font-weight-bold mb-0"
                            [innerHTML]="'test.sign.suitability'|translate"
                            *ngIf="isSuitability"
                        ></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-sign-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1 mb-0" />
            </div>

            <div class="col-12">
                <div class="bg-gray-gradient px-2 pt-4 pb-5">
                    <h3 class="mat-subheading-1 text-blue font-weight-bold mt-4">
                        {{ 'operative.documents'|translate }}

                        <mat-hint class="d-block mat-caption text-blue font-italic">
                            {{ 'form.documents-help'|translate:{size: 100} }}
                        </mat-hint>
                    </h3>
                    <div class="row justify-content-center">
                        <div class="col-12 col-sm-8 col-md-6 col-lg-4">
                            <button
                                type="button"
                                class="btn-download full-width mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                (click)="onDownload()"
                            >
                                {{ 'operative.download-sign-documentation'|translate }}
                                <i class="icon-download"></i>
                            </button>
                        </div>
                        <div class="col-12 col-sm-8 col-md-6 col-lg-4 mt-3 mt-md-0">
                            <input
                                #signedDocument
                                name="signedDocument"
                                type="file"
                                class="custom-file-input"
                                accept="image/jpeg,image/png,application/pdf"
                                (change)="onFileChange($event)"
                                multiple
                            />
                            <button
                                type="button"
                                class="btn-upload full-width mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="!canUpload"
                                (click)="onUpload()"
                            >
                                {{ 'operative.upload-sign-documentation'|translate }}
                                <i class="icon-download"></i>
                            </button>
                            <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="documentError"> {{ documentError }} </mat-error>
                        </div>
                        <div class="col-12 col-sm-8 col-md-6 col-lg-4 mt-3 mt-lg-0">
                            <button
                                type="button"
                                class="btn-validate full-width mat-elevation-z0"
                                color="gray-light"
                                mat-flat-button
                                [disabled]="!canAccept"
                                (click)="onValidate()"
                            >
                                {{ 'operative.finish-signature-process'|translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
